// src/hooks/useEnsureDisplayName.js
// The name step shared by every screen that creates or joins a room: show
// "Playing as X · Change" when a name is saved, an inline box when it isn't,
// and save the typed name the first time it's used.
import { useEffect, useState } from "react";
import useProfileStore from "../stores/profileStore";

export default function useEnsureDisplayName() {
  const { displayName, loadDisplayName, saveDisplayName, syncToAccount } = useProfileStore();
  // Only used until a name is saved; after that the saved name is used.
  const [draftName, setDraftName] = useState("");
  const [showEditName, setShowEditName] = useState(false);

  useEffect(() => {
    loadDisplayName();
  }, [loadDisplayName]);

  /** The name to play under. Throws with a player-facing message if a
   *  first-time typed name isn't valid. */
  const ensureName = async () => {
    if (displayName) return displayName;
    await saveDisplayName(draftName);
    return draftName.trim();
  };

  return {
    displayName,
    playerName: displayName || draftName,
    draftName,
    setDraftName,
    showEditName,
    setShowEditName,
    ensureName,
    syncToAccount,
  };
}
